import { useEffect, useState } from "react"

//PrimeReact
import { InputNumber } from "primereact/inputnumber"
import { Button } from "primereact/button"

//Styles
import myStyles from "../../../styles/developerTools/DevToolsServiceUrls.module.css"

export default function ActivitySetting({ setting, onOverride }) {
  const [value, setValue] = useState("")

  useEffect(() => {
    //Check if the URL is currently overridden
    if (setting.newOverride) {
      setValue(setting.newOverride)
    } else if (setting.activeOverride?.overrideValue) {
      setValue(setting.activeOverride.overrideValue)
    } else {
      setValue(setting.defaultSetting)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setting.defaultSetting, setting.activeOverride, setting.newOverride])

  const setOverrideValue = (value, reset = false) => {
    setValue(value)
    onOverride(value, reset)
  }

  let status = value === setting.defaultSetting ? "" : "Overridden"

  if (status !== "" && value !== setting.activeOverride?.overrideValue) {
    status = `${status} (New)`
  } else if (status !== "") {
    status = `${status}`
  }

  return (
    <div className={myStyles.serviceLayout}>
      <div className={myStyles.mainBodyLayoutName}>
        {setting?.description || "Unknown service"}{" "}
        {status ? (
          <span className={myStyles.overriddenServiceTag}>{status}</span>
        ) : null}
      </div>
      <div className={myStyles.mainBodyLayoutUrl}>
        <InputNumber
          className={myStyles.urlInput}
          value={value}
          onChange={(e) => {
            setOverrideValue(e.value)
          }}
          min={1}
          maxFractionDigits={0}
        />
      </div>
      <div className={myStyles.mainBodyLayoutReset}>
        <Button
          className={myStyles.resetButton}
          onClick={() => {
            setOverrideValue(setting.defaultSetting, true)
          }}
        >
          <span className="material-icons">refresh</span>
        </Button>
      </div>
    </div>
  )
}
